import { NgClass } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';

/**
 * User avatar component.
 * 
 * This component gets avatar data from AccountService and render it.
 */
@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [NgClass],
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnDestroy {
  @Input() size: "small" | "large" = "small";

  avatar: string = "";

  private subscription: Subscription;

  constructor(private account: AccountService) {
    this.subscription = this.account.avatar$.subscribe(avatar => {
      this.avatar = avatar;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
